module.exports = __webpack_public_path__ + "static/img/iconLogo.c5a6172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconLogo.png
// module id = iYIv
// module chunks = 101